import { useSnackbar } from 'contexts/snackbar';
import { Button, Text } from 'shell/components';

const SnackbarDemo = () => {
    const { message } = useSnackbar();

    const handleClick = (type) => () => {
        switch (type) {
            case 'success':
                message.success('Enter success message here.');
                break;
            case 'warning':
                message.warning('Enter warning message here.');
                break;
            case 'error':
                message.error('Enter error message here.');
                break;
            default:
                throw new Error();
        }
    };

    return (
        <>
            <Text variant={'sh1'}>Snackbar</Text>
            <Button onClick={handleClick('success')}>Open Success System Notification</Button>
            <Button onClick={handleClick('warning')}>Open Warning System Notification</Button>
            <Button onClick={handleClick('error')}>Open Error System Notification</Button>
        </>
    );
};

export default SnackbarDemo;
